const serialize = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

const dmnSetCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

const dmnGetCookie = (cname) => {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const dmnAjaxCall = async (endpoint, queryData) => {
  
  var data;

  if(queryData instanceof FormData) {
    data = queryData;
  } else {
    data = new FormData();
    for (const [key, value] of Object.entries(queryData)) {
      data.set(key, value);
    }
  }

  data.set('action', 'dmn_ajax_call');
  data.set('endpoint', endpoint);
  data.set('nonce', dmnobj.dmn_nonce);

  let response, error = null;

  try {
    const res = await fetch(dmnobj.ajax_url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      // headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: data,
    });

    if (!res.ok) {
      error = res.status;
      throw new Error(`Response status: ${res.status}`);
    }

    response = await res.json();
    // stationsData.value = json.markers;

  } catch (e) {
    error = e;
    console.error(r.message);
  }
  return { response, error };
};

export { dmnAjaxCall, dmnSetCookie, dmnGetCookie };
